<template>
	<el-dialog title="地区选择" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
		:visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog"  width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
		@close="dialogClose" v-el-drag-dialog v-el-dialog-center>
		<template>
			<div id="containt">
				<div class="grid-height">

					<div class="table_main" style="height: 400px!important;">
						<el-cascader :props="areaProps" v-model="ruleForm.org_list" :clearable="true" style="width: 100%;" :options="orgOptions"
                      @expand-change="expandChange" filterable @change="handleChange" :show-all-levels="false" collapse-tags  ref="cascaderAddr">
                    </el-cascader>
					</div>
				</div>
			</div>
		</template>
		<span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'
import request from "@/router/axios";

import { checkedChildren, cancelChildren } from './address'
import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
export default {
	name: 'saleConfigDialog',
	props: ['visiable', 'multi', 'param','siteId'],
	mixins: [selectDialogMixins],
	components: { pager },

	created() {
		this.initSetting();
    this.formData.siteId = this.siteId
    // if (this.param.partsCode) {
    //   this.formData.partsCode = this.param.partsCode
    // }
	},


    watch: {
        'ruleForm.org_list': {
          deep: true,
          handler(newArr, oldArr) {
            if (newArr && newArr.length) {
              const current = this.findCurrentDepartment(newArr, oldArr)
              if (!current) return
              this.$nextTick(() => {
                if (current.type === 'checked') {
                  // 从级联选择器中取出内部的节点数组，找到当前节点
                  let targetNode = ''
                  this.checkedNode = this.$refs.cascaderAddr.checkedNodes // 保存选中的节点, 取消用到
                  targetNode = this.$refs.cascaderAddr.checkedNodes.find((item) => {
                    return item.value === current.value
                  })
                  if (targetNode) {
                    // 递归找出所有子孙节点，并手动勾选
                    checkedChildren([targetNode])
                    // 更新视图
                    this.$refs.cascaderAddr.$refs.panel.calculateMultiCheckedValue()
                  }
                } else if (current.type === 'cancel') {
                  // 从级联选择器中取出内部的节点数组，找到当前节点
                  let targetNode = ''
                  targetNode = this.checkedNode.find((item) => {
                    return item.value === current.value
                  })
                  // console.log('选中的节点', this.checkedNode)
                  // console.log('===========', targetNode)
                  if (targetNode) {
                    // 递归找出所有子孙节点，并手动取消勾选
                    cancelChildren([targetNode])
                    // console.log('修改之后的节点树', cancelChildren([targetNode]))
                    // 更新视图
                    this.$refs.cascaderAddr.$refs.panel.calculateMultiCheckedValue()
                  }
                }
              })
            }
          }
        }
    },

	data() {
		return {
      formData:{
        siteId:null
      },
			ruleForm: {
               org_list: []
            },
            orgOptions: [],
            checkedNode: '',// 保存上次选中的Node节点

			selectedOptions: [],
			getAreaDataUrl: '/basic/basArea/getList',

			address:'',
      total: 0,
			filterText: '',
			data: [],
			defaultProps: {
				children: 'children',
				label: 'label',
				id: "id",
				isLeaf: "leaf"
			},
			pageSizes: [10, 20, 100],
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			showDialog: true,
			falseValue: false,
			selectMulti: true,
			areaProps: {
        multiple: true,
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },

		};
	},


	methods: {
		   // 判断当前操作是选中还是取消
		   findCurrentDepartment(newArr, oldArr) {
          const catchNewArr = [...newArr]
          const catchOldArr = [...oldArr]
          if (catchNewArr.length > catchOldArr.length) {
            // console.log('为添加')
            for (let i = 0; i < catchNewArr.length; i++) {
              const targetIndex = catchOldArr.indexOf(catchNewArr[i])
              if (targetIndex === -1) {
                return {
                  value: catchNewArr[i],
                  type: 'checked'
                }
              }
            }
          } else {
            // console.log('为取消')
            // console.log(catchOldArr, catchNewArr)
            for (let i = 0; i < catchOldArr.length; i++) {
              const targetIndex = catchNewArr.indexOf(catchOldArr[i])
              if (targetIndex === -1) {
                return {
                  value: catchOldArr[i],
                  type: 'cancel'
                }
              }
            }
          }
        },

	    // 地址三级联动
		cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: this.getAreaDataUrl,
        method: 'post',
        data: {
          parentId: node.value,
          siteId:this.formData.siteId
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};

        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },
	handleChange(e){
		console.log(e,'最后一级选择的数据');
		this.idList=e

	},
	// 父
	expandChange(selectedOptions) {
			this.selectedOptions = selectedOptions;
			console.log(selectedOptions,"父级选择的数据");


      let areaNodes = this.$refs["cascaderAddr"].getCheckedNodes();
      console.log(areaNodes,"areaNodes全部选中的值");
	//   let filterArr = [];
	//   let j = 0;
	//   for (let i = 0; i < areaNodes.length; i++) {
    //   if (areaNodes[i].level = 3) {
	// 	filterArr[filterArr.length] = areaNodes[i];
    //   }
    // }
    // console.log(filterArr,"3级市");





	  var idLists=Array.from(areaNodes,({value})=>value);
	  console.log(idLists,"选中的id1111");
	  this.idList=idLists











    //   let areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
    //   areaNode = areaNode.filter(option => !(option.parent && option.parent.checked))

    //   console.log(areaNode,"areaNode11111");

    //   let CheckedNodes = this.$refs["cascaderAddr"].getCheckedNodes();
    //   // // console.log(CheckedNodes, '11111111')
    //   CheckedNodes = CheckedNodes.filter(option => (option.parent && option.parent.checked))
    //   console.log(CheckedNodes,"CheckedNodes2222的值");



    //   this.area.temp = {
    //     id: areaNode[0].value,
    //     level: areaNode[0].level
    //   }
    //   const panelRefs = this.$refs.cascaderAddr.$refs.panel
    //   if (panelRefs.activePath.length !== 0) {
    //     panelRefs.activePath.forEach(item => {
    //       if (item.children.length === 0) {
    //         panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
    //       }
    //     })
    //   }
    },







    commitRow() {
		this.$emit('addressList',this.idList )
			this.dialogClose()

		},


		// 分页功能
		changeTablePage(page, flag) {
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.initTableList();
		},

		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},

		// 搜索
		searchEvent() {
      this.formData.itemCode = this.searchItemCode
      this.formData.itemName = this.searchItemName
      this.formData.brandName = this.searchBrandName
			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
			this.flushed()
		},
	}
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
	top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
	top: 0.3em;
}

#containt .grid-height {
	height:400px;
}

::v-deep .el-dialog {
	// height: 700px;
	overflow: hidden;
}

::v-deep body .dialog-style {
	border-radius: 8px;
	-webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	// height: 700px;
	overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}

.table_main {
	padding-top: 5px;
	padding-left: 5px;
	border: 1px solid #ededed;
	// width: calc(100% - 215px);
	border-bottom: none;

	.el-pagination {
		padding: 2px;

	}
}

.left_tree {
	width: 205px;

	.title {
		text-align: left;
		width: 182px;
		padding: 7px 0 5px !important;
		font-size: 13px;
		color: rgba(58, 39, 39, 0.96);

		>span {
			position: relative;
			left: 4px;
			top: -3px;
		}
	}

	::v-deep.el-tree-node__label {
		width: calc(100% - 32px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: rgba(86, 86, 86, 0.96);
	}
}

.tree_icon {
	background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
	.el-tree-node {
		position: relative;
		padding-left: 0px;
	}

	.el-tree-node__content {
		margin-top: 0px;
	}

	.el-tree-node__children {
		padding-left: 16px;
	}

	.el-tree-node::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -26px;
		border-width: 1px;
		border-left: 1px dashed #d9d9d9;
	}

	.el-tree-node:last-child::before {
		height: 38px;
	}

	.el-tree-node::after {
		content: '';
		width: 24px;
		height: 1px;
		position: absolute;
		left: -3px;
		top: 12px;
		border-width: 1px;
		border-top: 1px dashed #d9d9d9;
	}

	&>.el-tree-node::after {
		border-top: none;
	}

	&>.el-tree-node::before {
		border-left: none;
	}

	.el-tree-node__expand-icon {
		font-size: 17px;

		// color: #000;
		&.is-leaf {
			color: transparent;
			// display: none;
		}
	}
}
  ::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
    font-size: 14px !important;
}
::v-deep .vxe-grid .vxe-grid--pager-wrapper {
    display: block;
    width: 100%;
    position: fixed;
    bottom: -38px !important;
    position: absolute !important;
    z-index: 9999999;
    background-color: #ffffff;
}

</style>
